export default __webpack_public_path__ + "static/media/carry-out.0222f856.svg";